
export const TOGGLE_STATUS = 'TOGGLE_STATUS'
export const SET_NAVIGATION = 'SET_NAVIGATION'
